import { FC } from 'react'
import { KLAVIYO_NEWSLETTER_FORM_ID } from '@portfolio/configs'

type Props = {
  /** Klaviyo embed form id. Defaults to the shared newsletter form. */
  formId?: string
  /** Extra class(es) for layout overrides on the embed container. */
  className?: string
}

/**
 * Target for a Klaviyo embedded form. The Klaviyo onsite script (klaviyo.js,
 * loaded via Google Tag Manager) detects the `klaviyo-form-<id>` class and
 * injects the published form into this element. Replaces the former HubSpot
 * `hbspt.forms.create` embeds.
 */
export const KlaviyoForm: FC<Props> = ({
  formId = KLAVIYO_NEWSLETTER_FORM_ID,
  className,
}) => {
  return (
    <div
      className={`klaviyo-form-${formId}${className ? ` ${className}` : ''}`}
    />
  )
}
